module.exports = __webpack_public_path__ + "img/fig01.81340446.jpg";